import React from "react";
import { useTranslation } from "react-i18next";
import { RoutesPaths } from "../Router/Constant";
import { Link, useNavigate } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const headerOffset = 80;
      const elementPosition = el.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    } else {
      navigate(`${RoutesPaths.LANDING}?section=${id}`);
    }
  };
  return (
    <div className="outerFooterSection">
      <div className="container-fluid maxContainerSection footerPadding">
        <div className="row">
          <div className="col-md-8">
            <div className="footerLeftSection">
              <img src="/assets/img/smsLogo.svg" alt="" />
              <p className="m-0">{t("footer_desc")}</p>
              <div className="socialLinks">
                <Link
                  to="https://www.linkedin.com/company/smshub-ao"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/assets/img/LinkedIn.svg" alt="" />
                </Link>
                <Link
                  to="https://www.instagram.com/smshub.ao"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/assets/img/Instagram.svg" alt="" />
                </Link>
              </div>
              <div className="socialLinks">
                <Link
                  to="https://apps.apple.com/us/app/smshub/id6479360256"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/assets/img/Appledownloadbutton.svg" alt="" />
                </Link>
                {/* <a
                  href="https://play.google.com/store/apps/details?id=com.mindmoverz.smshub"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/assets/img/Googledownloadbutton.svg" alt="" />
                </a> */}
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="footerRightSection">
              <div className="footerMenuLink">
                <h6 className="m-0">{t("menu")}</h6>
                <p className="m-0" onClick={() => scrollToSection("whySmsHub")}>
                  {t("why_smshub")}
                </p>
                <p className="m-0" onClick={() => scrollToSection("features")}>
                  {t("features")}
                </p>
                <p className="m-0" onClick={() => scrollToSection("useCases")}>
                  {t("use_cases")}
                </p>
                <p className="m-0" onClick={() => scrollToSection("steps")}>
                  {t("how_it_works")}
                </p>
                <p className="m-0" onClick={() => scrollToSection("pricing")}>
                  {t("pricing")}
                </p>
              </div>

              <div className="footerMenuLink">
                <h6 className="m-0">{t("contact")}</h6>
                <p className="m-0">geral@g-corporate.com</p>
                <p className="m-0">+244 935 516 476</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <hr />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <p className="m-0 rightReserve">
              © {currentYear} smshub. {t("all_rights_reserved")}
            </p>
          </div>
          <div className="col-md-6">
            <div className="policyandTerms">
              <p className="m-0">
                <Link to={RoutesPaths.PRIVACYPOLICY}>
                  {t("privacy_policy")}
                </Link>
              </p>
              <p className="m-0">
                <Link to={RoutesPaths.TERMSCONDITIONS}>
                  {t("terms_of_use")}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
